import { memo } from "react";

import { Trans } from "react-i18next";

import UnsupportedBrowserMessage from "./UnsupportedBrowserMessage";

const UnsupportedBrowser = ({ browserName, browserVersion }) => (
  <div
    className="neeto-molecules-browser-support-page"
    data-testid="browser-support-page"
  >
    <div className="neeto-molecules-browser-support-page__content">
      <h1 className="neeto-molecules-browser-support-page__header">
        <Trans i18nKey="neetoMolecules.browserSupport.unsupportedBrowser.title" />
      </h1>
      <p className="neeto-molecules-browser-support-page__desc">
        <UnsupportedBrowserMessage
          {...{ browserName, browserVersion }}
          className="neeto-ui-text-body1"
        />
      </p>
    </div>
  </div>
);

export default memo(UnsupportedBrowser);
